<template>
    <div>
        <FacilityInfoWin ref="facilityInfoWin"
            v-on:loaded-facility-info="loadedFacilityInfoHandle" />
    </div>
</template>

<script>
import { $_TYPE, $_WC, $_NM } from '@/confs/common.const';
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import FacilityInfoWin from '@/views/common/FacilityInfoWin.vue';
import { mapGetters } from "vuex";
export default {
    components: {
        FacilityInfoWin,
    },
    computed: {
        ...mapGetters({
            facilitiesMenu: 'getFacilitiesMenu',
            uticCctvList: 'getUticCctvList',
            uticCctvPopUrl: 'getUticCctvPopUrl',
        }),
    },
    data(){
        return {
            overlays: [],
        };
    },
    watch: {
        // 시설정보 체크박스 선택 변경 감지
        facilitiesMenu: {
            immediate: false,
            deep: true,
            handler (newVal, oldVal) {
                // this.showTrafficLayer = false;
                this.showFacilityMarkers();
            }
        },
    },
    created() {
        this.$eventBus.$on('NaverMap::map-loaded', (map)=>{
            this.makeTrafficLayer();
        });
        this.$eventBus.$on('NaverMap::map-moved', ()=>{
        });
    },
    methods: {
        showFacilityMarkers() {
            if(typeof this.map !== $_TYPE.UNDEF) {
                for(let facType in this.facilitiesMenu) {
                    this.facilitiesMenu[facType].forEach((facItem)=>{
                        if(typeof this[facItem.id] === 'function') {
                            this[facItem.id].call(this, facItem);
                        }
                    });
                }
            }
        },

        // 안전센터
        safetyCenter(facItem) {
            this.facMarkerConf(facItem.id, facItem.isChecked, "FETCH_SAFETY_CENTER_LIST", "getSafetyCenterList", (event, facilityData, marker)=>{
                facilityData.facItemNm = "소방시설";
                facilityData.facName = facilityData.val1;
                this.$refs.facilityInfoWin.setFacilityInfo(facilityData);
            });
        },
        // 의료시설
        medicalFac(facItem) {
            this.facMarkerConf(facItem.id, facItem.isChecked, "FETCH_MEDICAL_FAC_LIST", "getMedicalFacList", (event, facilityData, marker)=>{
                facilityData.facItemNm = "의료시설";
                facilityData.facName = facilityData.val1;
                this.$refs.facilityInfoWin.setFacilityInfo(facilityData);
            });
        },

        // 경찰서
        police(facItem) {
            this.facMarkerConf(facItem.id, facItem.isChecked, "FETCH_POLICE_LIST", "getPoliceList", (event, facilityData, marker)=>{
                facilityData.facItemNm = "경찰서";
                facilityData.facName = facilityData.val1;
                this.$refs.facilityInfoWin.setFacilityInfo(facilityData);
            });
        },

        // 교통상황
        trafficState(facItem) {
            this.showTrafficLayer(facItem.isChecked);
        },

        uticCctv(facItem) {
            this.showUticCctvMarkers(facItem);
        },

        uticRoadCctv(facItem) {
            this.showUticCctvMarkers(facItem);
        },

        realcityCctv(facItem) {
            this.showUticCctvMarkers(facItem);
        },

        // 환경센서
        envSensor(facItem) {
            this.facMarkerConf(facItem.id, facItem.isChecked, "FETCH_ENV_SENSOR_LIST", "getEnvSensorList", (event, facilityData, marker)=>{
                facilityData.facItemNm = "환경센서";
                facilityData.facName = facilityData.val1;
                this.$refs.facilityInfoWin.setFacilityInfo(facilityData);
            });
        },

        // 대기오염측정소
        airPollution(facItem) {
            this.facMarkerConf(facItem.id, facItem.isChecked, "FETCH_AIR_POLLUTION_LIST", "getAirPollutionList", (event, facilityData, marker)=>{
                facilityData.facItemNm = "대기오염측정소";
                facilityData.facName = facilityData.val1;
                this.$refs.facilityInfoWin.setFacilityInfo(facilityData);
            });
        },

        // 수질측정소
        reservoir(facItem) {
            this.facMarkerConf(facItem.id, facItem.isChecked, "FETCH_WATER_RESERVOIR_LIST", "getWaterReservoirList", (event, facilityData, marker)=>{
                facilityData.facItemNm = "수질측정소";
                facilityData.facName = facilityData.val3;
                this.$refs.facilityInfoWin.setFacilityInfo(facilityData);
            });
        },
        reservoir(facItem) {
            this.facMarkerConf(facItem.id, facItem.isChecked, "FETCH_WATER_RESERVOIR_LIST", "getWaterReservoirList", (event, facilityData, marker)=>{
                facilityData.facItemNm = "수질측정소";
                facilityData.facName = facilityData.val3;
                this.$refs.facilityInfoWin.setFacilityInfo(facilityData);
            });
        },
        heatWave(facItem) {
            this.facMarkerConf(facItem.id, facItem.isChecked, "FETCH_SHADE_CANOPY_LIST", "getShadeCanopyList", (event, facilityData, marker)=>{
                facilityData.facItemNm = "그늘막시설";
                facilityData.facName = facilityData.val1;
                this.$refs.facilityInfoWin.setFacilityInfo(facilityData);
            });
        },

        facMarkerConf(code, checked, dispatchName, getterName, clickHandle, imgName) {
            if(typeof imgName === $_TYPE.UNDEF) {
                imgName = code;
            }
            if(checked) {
                if(this.hasMarkers(code)) {
                    this.showMarkerCtrl(code, true);
                } else {
                    let facilityList = this.$store.getters[getterName];
                    if(typeof facilityList === $_TYPE.UNDEF) {
                        this.$store.dispatch(dispatchName).then(()=>{
                                facilityList = this.$store.getters[getterName];
                                facilityList.forEach(function(facilityData) {
                                    let imgFileNm = 'marker_' + code + '.png';
                                    this.makeMarker(code, facilityData, clickHandle, imgFileNm, 'img/marker/', $_NM.MARKER_W, $_NM.MARKER_H);
                                }, this);
                                this.showMarkerCtrl(code, true);
                        });
                    } else {
                        this.showMarkerCtrl(code, true);
                    }
                }
            } else {
                this.showMarkerCtrl(code, false);
            }
        },
        showMarkerCtrl(code, isShow) {
            this.showMarkers(code, isShow, false);
        },
        loadedFacilityInfoHandle(content){
            this.openInfoWin(content);
        },
        showUticCctvMarkers(facItem) {
            let code = facItem.id;
            let imgNm = facItem.id;
            if(facItem.id == 'realcityCctv') {
                imgNm = 'uticCctv';
            }
            if(facItem.id == 'uticRoadCctv') {
                imgNm = 'uticCctv';
            }
            let imgFileNm = 'marker_' + imgNm + '.png';
            if(facItem.isChecked) {
                this.uticCctvList.forEach((cctv)=>{
                    let marker =this.makeMarker(code, cctv, (event, cctv, marker)=>{
                        let cctvid = cctv.val1;
                        let cctvName = cctv.val2;
                        let kind = cctv.val9;
                        if(cctvid.substring(0, 3) == 'L01'){
                            kind = 'Seoul';
                        } else if(cctvid.substring(0, 3) == 'L02'){
                            kind = 'N';
                        } else if(cctvid.substring(0, 3) == 'L03'){
                            kind = 'O';
                        } else if(cctvid.substring(0, 3) == 'L04'){
                            kind = 'P';
                        } else if(cctvid.substring(0, 3) == 'L08'){
                            kind = 'd';
                        }
                        let cctvip = 'null';
                        let cctvch = cctv.val5;
                        let id = cctv.val3;
                        let cctvpasswd = typeof cctv.val7 === $_TYPE.UNDEF || cctv.val7 === '' ? 'null' : cctv.val7;
                        let cctvport = typeof cctv.val4 === $_TYPE.UNDEF || cctv.val4 === '' ? 'null' : cctv.val4;

                        let overlay = this.uticCctvWin(cctvid, cctvName, kind, cctvip, cctvch, id, cctvpasswd, cctvport,
                            this.map, marker);

                        if(overlay) {
                            // 오버레이 초기화
                            this.initOverlays();
                            this.overlays.push(overlay);
                            overlay.setMap(this.map);
                        }

                    }, imgFileNm, 'img/marker/', $_NM.MARKER_W, $_NM.MARKER_H);
                });
                this.showMarkerCtrl(code, true);
            } else {
                this.initOverlays();
                this.showMarkerCtrl(code, false);
            }
        },
        initOverlays: function() {
            if(this.overlays) {
                this.overlays.forEach(function(overlays) {
                    overlays.setMap(null);
                }.bind(this));
            }
        },
        uticCctvWin(cctvid, cctvName, kind, cctvip, cctvch, id, cctvpasswd, cctvport, map, selectedMarker) {
            let videoUrl = 'http://www.utic.go.kr/view/map/openDataCctvStream.jsp';
            if(!!this.uticCctvPopUrl) {
                videoUrl = this.uticCctvPopUrl;
            }
            videoUrl += '?key=7PGTTIubOMcfDIROCei0EyzMN9PaCn7ehxhxr9uI3KI830PMk4p8OoJCqBUPTC';
            // let videoUrl = '/view/map/cctvStream.jsp?key=7PGTTIubOMcfDIROCei0EyzMN9PaCn7ehxhxr9uI3KI830PMk4p8OoJCqBUPTC';
            videoUrl += '&cctvid=' + cctvid;
            videoUrl += '&cctvName=' + encodeURIComponent(encodeURIComponent(cctvName));
            videoUrl += '&kind=' + kind;
            videoUrl += '&cctvip=' + cctvip;
            videoUrl += '&cctvch=' + cctvch;
            videoUrl += '&id=' + id;
            videoUrl += '&cctvpasswd=' + cctvpasswd;
            videoUrl += '&cctvport=' + cctvport;
            if(window.location.protocol.indexOf('https') > -1) {
                // ssl의 경우 팝업으로.. 확대 불가능
                let width = 345;
                let height = 330;
                let top = (window.screen.height - height) / 2;
                let left = (window.screen.width - width) / 2;
                let popCctv = window.open(videoUrl, 'PopupCctv',"top=" + top + "px, left=" + left + "px, width=" + width + "px, height=" + height+ "px, menubar=no, location=no, toolbar=no, scrollbars=no, status=no, resizable=no");
                popCctv.focus();
                return;
            }

            let fontSize = 12;
            let html = "<div class='cctv_popup'>";
            html += '   <div class="cctv_close cctv_x"><a href="javascript: void(0);" class="self-close-btn">닫기</a></div>';
            // html += "   <div class='cctv_title'><span>&nbsp;" + cctvName + "</span> <span style='float:right;' class='cctv_wide'>[화면확대]</span></div>";
            html += "   <div class='cctv_title'><span>&nbsp;" + cctvName + "</span></div>";
            html += "   <div class='cctv_movie'>";
            html += "       <iframe src="+videoUrl+" scrolling='no' style='width: 100%; height:95%; margin-top: -32px;' allowfullscreen></iframe>";
            html += "   </div>";
            html += "<div class='cctv_desc' style='position: relative; bottom:11%; margin-left:2%; font-size:"+fontSize+"px; color:#949294;'>";
            html += "<span style='display: block;'> 20초 동안 재생되며 끊김 현상이 발생할 수 있음";
            html += "</span>";
            html += "</div>";
            html += "</div>";

            let CctvOverlay = function(options) {
                this._element = $(html);
                this.setPosition(options.position);
                this.setMap(options.map || null);
            }

            CctvOverlay.prototype = new naver.maps.OverlayView();
            CctvOverlay.prototype.constructor = CctvOverlay;

            CctvOverlay.prototype.setPosition = function(position) {
                this._position = position;
                this.draw();
            };

            CctvOverlay.prototype.getPosition = function() {
                return this._position;
            };

            CctvOverlay.prototype.onAdd = function() {
                let paneName = "floatPane";
                let floatPane = this.getPanes()[paneName];
                this._element.appendTo(floatPane);
            };

            CctvOverlay.prototype.draw = function() {
                if (!this.getMap()) {
                    return;
                }

                let projection = this.getProjection();
                let position = this.getPosition();
                let pixelPosition = projection.fromCoordToOffset(position);
                let heightOffset = this._element.height() + selectedMarker.icon.size.height;
                let widthOffset = this._element.width() / 2;

                this._element.css('left', pixelPosition.x - widthOffset);
                this._element.css('top', pixelPosition.y - heightOffset);

                // this._element.draggable();
                this._element.on('mousedown', function() {
                    map.setOptions({ //지도 인터랙션 끄기
                        draggable: false,
                        pinchZoom: false,
                        scrollWheel: false,
                        keyboardShortcuts: false,
                        disableDoubleTapZoom: true,
                        disableDoubleClickZoom: true,
                        disableTwoFingerTapZoom: true
                    });
                });

                this._element.on('touchstart', function() {
                    map.setOptions({ //지도 인터랙션 끄기
                        draggable: false,
                        pinchZoom: false,
                        scrollWheel: false,
                        keyboardShortcuts: false,
                        disableDoubleTapZoom: true,
                        disableDoubleClickZoom: true,
                        disableTwoFingerTapZoom: true
                    });
                });

                this._element.on('mouseup', function() {
                    map.setOptions({ //지도 인터랙션 끄기
                        draggable: true,
                        pinchZoom: true,
                        scrollWheel: true,
                        keyboardShortcuts: true,
                        disableDoubleTapZoom: false,
                        disableDoubleClickZoom: false,
                        disableTwoFingerTapZoom: false
                    });
                });


                this._element.on('touchend', function() {
                    map.setOptions({ //지도 인터랙션 끄기
                        draggable: true,
                        pinchZoom: true,
                        scrollWheel: true,
                        keyboardShortcuts: true,
                        disableDoubleTapZoom: false,
                        disableDoubleClickZoom: false,
                        disableTwoFingerTapZoom: false
                    });
                });
            };

            CctvOverlay.prototype.onRemove = function() {
                let overlayLayer = this.getPanes().overlayLayer;
                this._element.remove();
                this._element.off();
            };

            let overlay = new CctvOverlay({
                position: selectedMarker.getPosition()
            });

            // 중심좌표 이동
            map.setCenter(new naver.maps.LatLng(selectedMarker.getPosition().y, selectedMarker.getPosition().x));

            // CCTV 창 닫기 Event
            overlay._element.find(".cctv_x").on("click", function() {
                overlay.setMap(null);

                $(".map_ctmenu").css("display", "");
                $(".map_navigation").css("display", "");
                $(".map_satellite").css("display", "");
                $(".cctv_legend").css("display", "");
            }.bind(this));

            //전체화면 Event
            // overlay._element.find(".cctv_wide").on("click", function() {
            //     this.showWideCctv(videoUrl);
            //     this.uticTitle = cctvName;
            // }.bind(this));

            return overlay;
        },
    },
    mixins: [naverMapShareMixins],
};
</script>
